<div class="tile-card-structure forecast-table-main-block mt-4" [hidden]="!isForecastTableDataLoaded">
  <div class="forcast-tile">
    <div class="application-label">
      <p class="m-0">
        Application View @if (pendAttesCount > 0) {
        <span class="pending-attes ms-4"
          >{{ forecastCycleType?.type == 'Off-cycle' ? 'Pending Updates:' : 'Pending Attestation:' }}
          <span class="custom-chip-block">
            <mat-chip
              class="custom-chip"
              (click)="applyPendingAttesFilter()"
              [removable]="isPendingAttesFilterApplied"
              (removed)="clearPendAttesFilter()"
              >{{ pendAttesCount }}@if (isPendingAttesFilterApplied) {
              <mat-icon matChipRemove title="Reset Filter">restart_alt</mat-icon>
              }</mat-chip
            >
          </span>
        </span>
        }
      </p>
    </div>
    <div class="forecast-options">
      <p class="m-0 me-4">Forecast : FC</p>
      <div class="toggle-div ">
        <span class="toggle-label switch-toggle-label table-data-font  me-1">By Volume</span>
        <mat-slide-toggle
          [color]="'#013b71'"
          [disabled]="forecastTableData?.length == 0"
          class="switch-toggle"
          [checked]="toggleChecked"
          (change)="toggleChanged($event)"
          #toggle
        ></mat-slide-toggle>
        <span class="toggle-label  switch-toggle-label table-data-font  ms-1 me-4">By Charge</span>
      </div>
      @if (dataSource?.data.length > 0) {
      <div class="me-3">
        <button
          (click)="expandAllFunc()"
          class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
        >
          {{ allRowsExpanded ? 'Collapse All' : 'Expand All' }}
        </button>
      </div>
      }
      <span
        class="pr-03"
        [attr.Pixel-tracking]="true"
        [attr.Pixel-title]="'Add Service click'"
        (click)="addServiceWithApp('app')"
        title="Click to Add an Application"
      >
        <img class="add-service-img" src="../../assets/imagesV4/Add_service.png" />
      </span>
      <div>
        <span class="me-3" (click)="openReportLink($event)" title="Click to view the infrastructure Forecast details">
          <img class="add-report-link-img" src="../../assets/imagesV4/Link.png" />
        </span>
      </div>
      <div class="download-wrapper" (mouseleave)="showDropdownMenu = false" (mouseenter)="showDropdownMenu = true">
        <div class="export-link">
          <span
            class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"
            [ngClass]="{ 'disable-export-icon': forecastTableData?.length == 0 }"
          ></span>
        </div>
        @if (showDropdownMenu && forecastTableData?.length > 0) {
        <div class="excel-dropdown-list">
          @if (excelDropdownData.length > 0) { @for (item of excelDropdownData; track item) {
          <button mat-menu-item [disabled]="exportLoading" (click)="!exportLoading && exportData(item)">
            @if (loadingExportKey === item.key) { &nbsp;<mat-spinner
              diameter="14"
              class="export-item-spinner"
            ></mat-spinner
            >&nbsp; }
            <span class="export-item-label" [class.w-90]="isJSONeditorEnabled">{{ item.value }}</span>
            @if (isJSONeditorEnabled) {
            <span
              class="item-edit-icon"
              (click)="$event.stopPropagation(); openJsonEditorForItem(item)"
              title="Edit JSON"
            >
              <mat-icon>create</mat-icon>
            </span>
            } @if (isJSONeditorEnabled) {
            <span
              class="item-edit-icon ms-1"
              (click)="$event.stopPropagation(); deleteReport(item)"
              title="Delete Report"
            >
              <mat-icon>delete</mat-icon>
            </span>
            }
          </button>
          } }
        </div>
        }
      </div>
    </div>
  </div>

  <div class="table-container">
    <table
      mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z8"
      multiTemplateDataRows
      matSort
      #empTbSort="matSort"
      (matSortChange)="sortData($event)"
    >
      @for (col of COLUMNS; track col) {
      <ng-container [matColumnDef]="col.key">
        @if (col.label != 'Action') {
        <th
          mat-header-cell
          mat-sort-header
          *matHeaderCellDef
          [style.width]="col.width"
          [style.textAlign]="col.align"
          [style.padding]="col.padding"
        >
          <span
            class="main-table-header-txt"
            [style.textAlign]="col.align"
            [ngClass]="{ 'label-left-align': col.paddingLeft }"
            >{{ col['label'] }}</span
          >
        </th>
        } @if (col.label == 'Action') {
        <th
          mat-header-cell
          *matHeaderCellDef
          [style.width]="col.width"
          [style.textAlign]="col.align"
          [style.padding]="col.padding"
        >
          <span class="main-table-header-txt">{{ col['label'] }}</span>
        </th>
        } @if (dataSource?.data.length > 0) {
        <td
          mat-cell
          *matCellDef="let element; let i = dataIndex"
          [style.textAlign]="col.align"
          [style.width]="col.width"
          [style.padding]="col.padding"
          [style.textAlign]="col.text_align"
        >
          @switch (col.key) { @case ('Actions') {
          <span>
            <div class="action-buttons">
              @if (( (isForecastAdmin || isForecastSRM) ? element.Admin_App_Edit == 'Yes' : element.App_Edit == 'Yes')
              && ((element.AO_AD_Edit && element.AO_AD_Edit.split(',').includes(currentUser)) || (element.FA_SFA_Edit &&
              element.FA_SFA_Edit.split(',').includes(currentUser))) && currentUser != '') {
              <span
                class="pr-03"
                [attr.Pixel-tracking]="true"
                [attr.Pixel-title]="'Add Service click'"
                (click)="addService(element, 'service')"
                title="Click to Add a Service"
              >
                <img class="add-service-img" src="../../assets/imagesV4/Add_service.png" />
              </span>
              }
              <span class="pe-03" title="view" (click)="applicationView(element)">
                <mat-icon class="uitk-icon uitk-icon-view sm-icon cancel-screen-icon icon-curd"></mat-icon>
              </span>
            </div>
          </span>
          } @default {
          <span class="margin-left-app">
            @if (col.link) {
            <span class="app-block">
              <span class="pr-1 pe-1">
                <mat-icon
                  class="expansion-icon"
                  style="cursor: pointer;"
                  (click)="element.expand ? collapseDetailRow(element) : expandDetailRow(element, true)"
                  >{{ element.expand ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon
                >
              </span>
              <span
                style="cursor: pointer;"
                class="w-100"
                (click)="element.expand ? collapseDetailRow(element) : expandDetailRow(element, true)"
              >
                {{ element[col.key] }}
              </span>
              <div class="arrow-button-block">
                <div
                  class="uitk-icon uitk-icon-arrow_wtail_bold_right arrow-icon "
                  matTooltip="View Application"
                  matTooltipClass="my-custom-tooltip"
                  matTooltipPosition="above"
                  (click)="viewApplication(col, element)"
                ></div>
              </div>
              <span class="app-report-block" (click)="navigateToDynamicReportPage(element)" title="View Report">
                <img class="add-report-link-img" src="../../assets/imagesV4/Link.png" />
              </span>
            </span>
            } @if (col.currency) { @if (element[col.key] != null) {
            <span [style.color]="col.color">${{ element[col.key] | digitFormatter: '1' }}</span>
            } } @if (col.key == 'cio_lob') {
            <span [style.color]="col.color">{{ element[col.key] }}</span>
            } @if (col.key == 'Billing_Segment') {
            <span [style.color]="col.color">{{ element[col.key] }}</span>
            } @if (col.key == 'decom_date') { @if (element[col.key]) {
            <span>{{ element[col.key] | date: 'mediumDate' }}</span>
            } }
          </span>
          } }
        </td>
        }
      </ng-container>
      }
      <div [hidden]="!TABLE_CONFIG.expandable">
        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="displayedColumns.length"
            style="background-color: #FFFFFF !important;"
          >
            @if (element.expand) {
            <div
              class="app-padu-element-detail"
              [hidden]="!element.childDataSource?.data"
              [@detailExpand]="element.expand ? 'expanded' : 'collapsed'"
            >
              <div class="inner-table mat-elevation-z8 table-container-inside">
                <table
                  #innerTables
                  #innerSort="matSort"
                  matSort
                  mat-table
                  [dataSource]="element.childDataSource"
                  class="mat-elevation-z8 child-table-class"
                  style="border-left: 0.03vw solid #013B71"
                  (matSortChange)="sortInnerTable($event, element)"
                >
                  <ng-container matColumnDef="No">
                    <th mat-header-cell *matHeaderCellDef [ngStyle]="{ position: 'relative' }">
                      <span
                        [ngClass]="{
                          'pend-attes':
                            element?.app_Update_Status_ui == 'Pending Attestation' ||
                            element?.app_Update_Status_ui == 'Pending Updates',
                          'comp-attes':
                            element?.app_Update_Status_ui == 'Attestation Completed' ||
                            element?.app_Update_Status_ui == 'Updates Completed',
                          'non-editable-attes': element?.app_Update_Status_ui == 'App Not Editable',
                          'attes-not-required':
                            element?.app_Update_Status_ui == 'Ateestation Not Required' ||
                            element?.app_Update_Status_ui == 'Attestation Not Required' ||
                            element?.app_Update_Status_ui == 'Updates Not Required'
                        }"
                        >{{ element?.app_Update_Status_ui }}@if (element?.pending_Services > 0) {
                        <span> : {{ element?.pending_Services }}</span>
                        }</span
                      >
                      @if (showUOMrateData) {
                      <mat-icon
                        aria-hidden="false"
                        (click)="showHideRateAndUOM()"
                        class="check-icon open-uom-icon"
                        fontIcon="compress"
                      ></mat-icon>
                      }
                    </th>
                  </ng-container>
                  <ng-container matColumnDef="rate_uom">
                    <th
                      mat-header-cell
                      [style.textAlign]="'center !important'"
                      [ngStyle]="{ position: 'relative' }"
                      *matHeaderCellDef
                      [attr.colspan]="3"
                    >
                      Rate & UOM @if (!showUOMrateData) {
                      <mat-icon
                        aria-hidden="false"
                        (click)="showHideRateAndUOM()"
                        class="check-icon open-uom-icon"
                        fontIcon="compress"
                      ></mat-icon>
                      }
                    </th>
                  </ng-container>
                  <ng-container matColumnDef="header1"><th mat-header-cell *matHeaderCellDef></th></ng-container>
                  <ng-container matColumnDef="header2"><th mat-header-cell *matHeaderCellDef></th></ng-container>
                  <ng-container matColumnDef="header3"><th mat-header-cell *matHeaderCellDef></th></ng-container>
                  <ng-container matColumnDef="header4"><th mat-header-cell *matHeaderCellDef></th></ng-container>
                  <ng-container matColumnDef="header5"><th mat-header-cell *matHeaderCellDef></th></ng-container>
                  <ng-container matColumnDef="header6"
                    ><th mat-header-cell *matHeaderCellDef class="no-right-border"></th
                  ></ng-container>
                  <ng-container matColumnDef="header7"><th mat-header-cell *matHeaderCellDef></th></ng-container>
                  @for (innerColumn of expanded_columns; track innerColumn) { @if (innerColumn.key != 'Action') {
                  <ng-container matColumnDef="{{ innerColumn.key }}">
                    <th
                      mat-header-cell
                      mat-sort-header
                      *matHeaderCellDef
                      class="table-light-background"
                      [style.width]="innerColumn.width"
                      [style.padding]="innerColumn.padding"
                      [style.textAlign]="innerColumn.textAlign"
                      [ngClass]="{ 'no-right-border': innerColumn?.noBorder }"
                    >
                      @if (innerColumn.key != 'sv_desc') {
                      <span [ngClass]="{ 'label-left-align': innerColumn.paddingLeft }">
                        {{ innerColumn.label }}
                      </span>
                      } @if (innerColumn.key == 'sv_desc') {
                      <span [ngClass]="{ 'p-25': innerColumn.paddingLeft }">
                        {{ innerColumn.label }}
                      </span>
                      }
                    </th>
                    <td
                      mat-cell
                      [style.width]="innerColumn.width"
                      [style.padding]="innerColumn.padding"
                      [style.textAlign]="innerColumn.textAlign"
                      *matCellDef="let element"
                      [ngClass]="{ 'no-right-border': innerColumn?.noBorder }"
                    >
                      <div>
                        @switch (innerColumn.key) { @default {
                        <span>
                          @if (innerColumn.key == 'Curr_Year_FC_Curr_Volume' || innerColumn.key ==
                          'Curr_Year_FC_Prev_Volume' || innerColumn.key == 'Future_Year_FC_Curr_Volume' ||
                          innerColumn.key == 'Future_Year_FC_Prev_Volume' || innerColumn.key ==
                          'Infra_projected_Volumes' || innerColumn.key == 'Prev_Year_FY_Volume') { @if
                          (element.volumes[innerColumn.key] != null) {
                          <span [style.color]="innerColumn.color">
                            {{ element.volumes[innerColumn.key] | digitFormatter: '1' }}
                          </span>
                          } } @if (innerColumn.key == 'Curr_Year_FC_Curr_Charges' || innerColumn.key ==
                          'Curr_Year_FC_Prev_Charges' || innerColumn.key == 'Future_Year_FC_Curr_Charges' ||
                          innerColumn.key == 'Future_Year_FC_Prev_Charges' || innerColumn.key ==
                          'Infra_projected_Charges' || innerColumn.key == 'Prev_Year_FY_Charges') { @if
                          (element.charges[innerColumn.key] != null) {
                          <span [style.color]="innerColumn.color">
                            ${{ element.charges[innerColumn.key] | digitFormatter: '1' }}
                          </span>
                          } } @if (innerColumn.key == 'sv_desc') { @if (element.SRV_Disable != 'DISABLE') {
                          <span class="flex-block ">
                            <span
                              class="label-block"
                              [ngClass]="showUOMrateData ? 'label-block-w-8' : 'label-block-w-15'"
                            >
                              <span
                                class="int-label-txt"
                                [hidden]="!(element.i_flag == 'Yes')"
                                matTooltipPosition="above"
                                matTooltip="Billed Under International Rate"
                                >INT</span
                              >
                            </span>
                            <span class="link-block">
                              <a
                                class="link-click"
                                href="javascript:void(0)"
                                (click)="navigateToViewService(element)"
                                >{{ element[innerColumn.key] }}</a
                              >
                            </span>
                            @if (element.attested_by != null) {
                            <mat-icon aria-hidden="false" class="check-icon greenbg" fontIcon="check_circle"></mat-icon>
                            } @if (element.attested_by_offc != null) {
                            <mat-icon
                              aria-hidden="false"
                              class="check-icon purplebg"
                              fontIcon="check_circle"
                            ></mat-icon>
                            }
                          </span>
                          } @if (element.SRV_Disable == 'DISABLE') {
                          <span class="flex-block ">
                            <span
                              class="label-block"
                              [ngClass]="showUOMrateData ? 'label-block-w-8' : 'label-block-w-15'"
                            >
                              <span
                                class="int-label-txt"
                                [hidden]="!(element.i_flag == 'Yes')"
                                matTooltipPosition="above"
                                matTooltip="Build Under International Rate"
                                >INT</span
                              >
                            </span>
                            <span
                              class="link-block"
                              matTooltipPosition="above"
                              [matTooltip]="element?.service_hover"
                              (click)="navigateToExternalLink(element.External_Link, element)"
                            >
                              <a href="javascript:void(0)" class="link-click ">{{ element[innerColumn.key] }}</a>
                            </span>
                            @if (element.attested_by != null) {
                            <mat-icon aria-hidden="false" class="check-icon greenbg" fontIcon="check_circle"></mat-icon>
                            }
                          </span>
                          } } @if (innerColumn.key == 'CY_Rate' || innerColumn.key == 'Future_Year_Rate' ||
                          innerColumn.key == 'PY_Rate') { @if (element[innerColumn.key] != null) {
                          <span [style.color]="innerColumn.color">
                            ${{ element[innerColumn.key] }} @if (innerColumn.isUnitOfMeasure &&
                            element[innerColumn.key]) {
                            <span class="unit_measure_txt"> / {{ element['Unit_Of_Measure'] }}</span>
                            }
                          </span>
                          } } @if (innerColumn.key == 'Prev_Year_FY_Charges' || innerColumn.key ==
                          'Infra_projected_Charges') { @if (element[innerColumn.key] != null) {
                          <span [style.color]="innerColumn.color">
                            ${{ element[innerColumn.key] | digitFormatter: '1' }}
                          </span>
                          } } @if (innerColumn.key == 'Prev_Year_FY_Volume' || innerColumn.key ==
                          'Infra_projected_Volumes') { @if (element[innerColumn.key] != null) {
                          <span [style.color]="innerColumn.color">
                            {{ element[innerColumn.key] | digitFormatter: '1' }}
                          </span>
                          } }
                        </span>
                        } }
                      </div>
                    </td>
                  </ng-container>
                  } @if (innerColumn.key == 'Action') {
                  <ng-container matColumnDef="{{ innerColumn.key }}">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="table-light-background"
                      [style.width]="innerColumn.width"
                      [style.padding]="innerColumn.padding"
                      [style.textAlign]="innerColumn.textAlign"
                    ></th>
                    <td
                      mat-cell
                      [style.width]="innerColumn.width"
                      [style.padding]="innerColumn.padding"
                      [style.textAlign]="innerColumn.textAlign"
                      *matCellDef="let element"
                    ></td>
                  </ng-container>
                  } }
                  <tr mat-header-row *matHeaderRowDef="displayedChildHeaders"></tr>
                  <tr mat-header-row *matHeaderRowDef="displayedChildColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedChildColumns" class="example-element-row"></tr>
                </table>
              </div>
            </div>
            }
          </td>
        </ng-container>
      </div>

      <tr mat-header-row class="" *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="row-height"></tr>

      <ng-container matColumnDef="nodata">
        <td mat-footer-row *matFooterCellDef [colSpan]="displayedColumns.length" style="text-align: center;">
          <div class="no-records-found">
            <div class="img-align">
              <img class="image-align" src="/assets/images/warning-icon.svg" />
            </div>
            <div class=" data-title">
              <div class="errorTitle">No Data Available</div>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-footer-row [hidden]="dataSource && dataSource.data.length > 0" *matFooterRowDef="['nodata']"></tr>

      @if (TABLE_CONFIG.expandable) {
      <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="example-detail-row"></tr>
      }
    </table>

    <div [hidden]="!(dataSource && dataSource.data.length > 0)">
      <ng-container>
        <mat-paginator
          #paginator
          [pageSize]="TABLE_CONFIG.pageSize"
          [length]="TABLE_CONFIG.totalItems"
          [pageSizeOptions]="[10, 20, 30]"
          showFirstLastButtons
          (page)="onPageChange()"
        ></mat-paginator>
      </ng-container>
    </div>
  </div>
</div>
<app-modal
  [maximizable]="true"
  [inViewport]="true"
  #viewForecastApplicationChart
  class="chart-view"
  (closeModal)="hideModal()"
>
  <ng-container class="app-modal-header">Application View</ng-container>
  <ng-container class="app-modal-body">
    <app-trend-chart-forecast
      [barcolor]="['#666261', '#494544', '#007C89']"
      [data]="Infra"
      [InfraData]="Infra"
      [forecastDetailsMap]="forecastDetailsMap"
    >
    </app-trend-chart-forecast>
  </ng-container>
</app-modal>
<app-modal [maximizable]="true" [inViewport]="true" #addServicePopup class="modal-demo add-service-popup">
  <ng-container class="app-modal-header">
    {{ modalType == 'service' ? 'Add Service' : 'Add New Application' }}</ng-container
  >
  <ng-container class="app-modal-body">
    <app-forecast-add-service-popup
      [dataSource]="appDataForAddService"
      [masterServicesData]="masterServicesData"
      [allNewApps]="allNewApps"
      [modalType]="modalType"
      (refreshService)="refreshServicesForApp($event)"
      [isForecastAdmin]="isForecastAdmin"
    >
    </app-forecast-add-service-popup>
  </ng-container>
</app-modal>

<app-export-file-popup
  #exportFileAsPopup
  (exportConfirmed)="confirmExportWithOptionalSuffix($event)"
  (popupClosed)="closeExportFileAsPopup()"
>
</app-export-file-popup>

<app-modal
  [maximizable]="true"
  [inViewport]="true"
  #jsonEditorPopup
  class="edit-json-popup"
  (closeModal)="closeJsonEditorItem()"
>
  <ng-container class="app-modal-header">Visual Editor</ng-container>
  <ng-container class="app-modal-body">
    @if (isJsonEditorPopupOpen) {
    <app-inbuilt-editor
      [initialJson]="activeDropdownItem?.raw_element_json || {}"
      [queryCode]="activeDropdownItem?.Constructed_Query || ''"
      (jsonTextChange)="onJsonEditorItemTextChange($event)"
    ></app-inbuilt-editor>
    }
  </ng-container>
</app-modal>
